import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './About.css';

class About extends React.Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
    title: PropTypes.string,
  };

  static defaultProps = {
    title: null,
  };

  render() {
    const { content, title } = this.props;

    return (
      <div>
        {title && (
          <h1 className={s.title}>
            <FormattedMessage id="Информация об автосалоне" /> {` ${title}`}
          </h1>
        )}
        <div className={s.root}>
          <div
            className={s.contentWrapper}
            ref={div => {
              this.container = div;
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(About);



// WEBPACK FOOTER //
// ./src/shared/components/About/About.js